<template>
  <CustomDropdown :placeholder="placeholder ? placeholder : $t('general.group')"
                  v-model:modelValue="innerModelValue"
                  :show-clear="showClear !== undefined ? showClear : true"
                  :dropdown-height="dropdownHeight"
                  :options="groups"/>
</template>

<script src="./AutoCompleteGroup.ts"></script>
